import axios from 'axios';
import constants from './../../constants';
import { Dispatch } from 'react';
import Cliente from '../../classes/cliente';

let sessionTimeout: ReturnType<typeof setTimeout>;

export const LOGIN_START = 'LOGIN_START';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const RESET_AUTH_STATE = 'RESET_AUTH_STATE';

export const INVALID_USER = 'INVALID_USER';

export const loginStart = () => ({ type: LOGIN_START });
export const loginError = () => ({ type: LOGIN_ERROR });
export const loginSuccess = (user: Cliente, token: string) => ({ type: LOGIN_SUCCESS, token, user });

export const invalidUser = (reason: string) => ({ type: INVALID_USER, reason });
export const resetAuthState = () => {
    clearTimeout(sessionTimeout);
    localStorage.removeItem('laportaMagAuth');
    return { type: RESET_AUTH_STATE };
};

const checkAuthTimeout = (expiresIn: number) => (dispatch: Dispatch<any>) => {
    sessionTimeout = setTimeout(() => {
        alert('Su sesión ha expirado. Por favor, ingrese sus credenciales nuevamente.');
        dispatch(resetAuthState());
    }, expiresIn);
};

export const authenticate = ({ 
    credentials = {}, 
    loginAction = false 
} = {}) => {
    return (dispatch: Dispatch<any>) => {
        dispatch(resetAuthState());
        dispatch(loginStart());

        return axios.post(`${constants.server}/${loginAction ? 'login' : 'signup'}`, credentials)
            .then(response => handleAuth(response.data, dispatch))
            .catch(() => dispatch(loginError()));
    };
};

export const isValidUser = (): boolean => {
    const { expirationDate, token } = JSON.parse(localStorage.getItem('laportaMagAuth') || '{}');
    const expiresIn = expirationDate ? expirationDate - new Date().getTime() : 0;
    return token !== '' && expiresIn > 0;
};

export const tryAutoLogin = () => (dispatch: Dispatch<any>) => {
    if (isValidUser()) {
        const { client, expirationDate, token } = JSON.parse(localStorage.getItem('laportaMagAuth') || '{}');
        const expiresIn = expirationDate ? expirationDate - new Date().getTime() : 0;
        dispatch(loginSuccess(client, token));
        dispatch(checkAuthTimeout(expiresIn));
        return;
    }

    dispatch(resetAuthState());
};

export const getHeaders = () => {
    const { token } = JSON.parse(localStorage.getItem('laportaMagAuth') || '{}');
    
    if (token) {
        return { 'Authorization': `Bearer ${token}` };
    }
};

const handleAuth = (data: any, dispatch: Dispatch<any>) => {
    const { client, err, expiresIn, token, validUser } = data;

    if (!validUser) {
        dispatch(invalidUser(err));
        return;
    }

    const expirationDate = new Date().getTime() + expiresIn;
    localStorage.setItem('laportaMagAuth', JSON.stringify({ client, expirationDate, token }));

    dispatch(loginSuccess(client, token));
    dispatch(checkAuthTimeout(expiresIn));
};